import { MarketButton, MarketDivider } from '@market/react';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { UNSUBSCRIBE_VALUES } from '.';
import nonTranslatableStrings from 'utils/nonTranslatableStrings';
import useCdpPageTracking, {
  Client_Namespace,
} from 'utils/custom-react-hooks/useCdpPageTracking';
import { viewMarketingUnsubscribed } from 'services/tracking/cdp/events/singleClickMarketingPreferences';

interface UnsubscribedProps {
  unsubscribedFrom: UNSUBSCRIBE_VALUES.MERCHANT | UNSUBSCRIBE_VALUES.GLOBAL;
  emailOptInId: string;
  obfuscatedEmail: string;
  merchantName: string;
  doResubscribe: Function;
  isResubscribing: boolean;
}

const Unsubscribed: React.FC<UnsubscribedProps> = (props) => {
  const { t } = useTranslation();

  /* CDP page view tracking */

  useCdpPageTracking({
    properties: viewMarketingUnsubscribed(
      props.emailOptInId,
      'email',
      props.unsubscribedFrom === UNSUBSCRIBE_VALUES.MERCHANT
        ? 'merchant'
        : 'all'
    ),
    isLoading: false,
    didLoadingFail: false,
    client: Client_Namespace.UNSUBSCRIBE,
  });

  /* Content */

  const resubscribeStyling = `hover:cursor-pointer no-underline font-bold ${
    props.isResubscribing ? 'text-grey' : 'text-blue'
  }`;
  const resubscribeOnClick = props.isResubscribing
    ? () => {}
    : props.doResubscribe;

  return (
    <>
      <h2>
        {t(
          'preference.components.MarketingSubscriptionCard.title.unsubscribed'
        )}
      </h2>
      <div>
        {props.unsubscribedFrom === UNSUBSCRIBE_VALUES.MERCHANT
          ? t(
              'preference.components.unsubscribe.marketing.unsubscribedFromMerchant.content',
              {
                merchantName: props.merchantName,
                obfuscatedEmail: props.obfuscatedEmail,
              }
            )
          : t(
              'preference.components.unsubscribe.marketing.unsubscribedFromGlobal.content',
              {
                SQUARE: nonTranslatableStrings.square,
              }
            )}
      </div>
      <div className={'mt-7 mb-7'}>
        {/* prettier formatting breaks the "resubscribe" link, so we turn it off for this code block. */}
        {/* prettier-ignore */}
        <Trans i18nKey="preference.components.unsubscribe.marketing.content.resubscribe">
          If you didn't mean to unsubscribe, you can <span className={resubscribeStyling} onClick={resubscribeOnClick}>resubscribe</span> now.
        </Trans>
      </div>

      <MarketDivider />

      <h3>{t('preference.components.loginCard.title.updatePreference')}</h3>

      <div>{t('unauthenticatedVerifyEmail.success.subtitle2')}</div>

      <MarketButton href={'/'} className={'mt-7'}>
        {t('unauthenticatedVerifyEmail.signIn')}
      </MarketButton>
    </>
  );
};

export default Unsubscribed;
